export const firebaseConfig = {
  apiKey: "AIzaSyA8VU36fHI3XA1dt0ukR9bC-H5OWY0YfRw",
  authDomain: "midas-rift.firebaseapp.com",
  databaseURL: "https://midas-rift.firebaseio.com",
  projectId: "midas-rift",
  storageBucket: "midas-rift.appspot.com",
  messagingSenderId: "171071276580",
  appId: "1:171071276580:web:022922356364c73aeefab1"
}